
export const evaluateStrength = password => {
    const patterns = {
        digit: /\d/,
        lowercase: /[a-z]/,
        uppercase: /[A-Z]/,
        symbol: /[$&+,:;=?@#|'<>.^*()%!-]/,
        eightChars: /^.{8,}$/,
        noSpaces: /^\S*$/, // no whitespace allowed
        twoDigits: /^.*(\d.*){2,}.*$/, // at least two digits
        twoSymbols: /(\W.*){2}/, // at least two symbols
    };

    let matchedPatterns = 0;
    for (let pattern in patterns) {
        if (patterns.hasOwnProperty(pattern)) {
            if (patterns[pattern].test(password)) {
                matchedPatterns++;
            }
        }
    }

    let strengthLevel; // Default to level 1 if the password is empty
    let text;

    if(password.length === 0) {
        strengthLevel = 1;
        text = 'Strength level'
        return [strengthLevel, text]
    }

    if (matchedPatterns === 1) {
        strengthLevel = 2; // Weak password
        text = 'Weak'
    } else if (matchedPatterns === 2) {
        strengthLevel = 3; // Weak password
        text = 'Weak'
    } else if (matchedPatterns === 3) {
        strengthLevel = 4; // Weak password
        text = 'Weak'
    } else if (matchedPatterns === 4) {
        strengthLevel = 5; // Medium password
        text = 'Medium'
    } else if (matchedPatterns === 5) {
        strengthLevel = 6; // Medium password
        text = "Medium"
    } else if (matchedPatterns === 6) {
        strengthLevel = 7; // Strong password
        text = "Strong"
    } else if (matchedPatterns === 7) {
        strengthLevel = 8; // Strong password
        text = "Strong"
    } else if (matchedPatterns === 8) {
        strengthLevel = 9; // Very strong password
        text = "Very Strong"
    } else if (matchedPatterns === 9) {
        strengthLevel = 10; // Very strong password
        text = "Very Strong"
    }

    return [strengthLevel, text];
}
